(function () {
    'use strict';

    angular
        .module('rms.common')
        .directive('simpleSortBar', simpleFilterBar);

    function simpleFilterBar() {
        return {
            restrict: 'E',
            controller: simpleFilterBarCtrl,
            controllerAs: 'vm',
            bindToController: true,
            templateUrl: 'common/app/components/list-filter/simple-sort-bar',
            scope: {
                options: '='
            }
        };
    }

    function simpleFilterBarCtrl($scope, lodash, $interval, ListFilterStateFactory) {
        const vm = this;
        var listFilterIdentifier = 'default';
        this.$onInit = function() {
            listFilterIdentifier = lodash.get(vm.options, 'identifier', 'default');

            vm.pageData = {};
            vm.currentDirection = null;

            vm.selectGroup = selectGroup;

            $scope.initInterval = $interval(function () {
                initListFilterService();
                if (!!$scope.listFilterService) {
                    $interval.cancel($scope.initInterval);
                    init();
                }
            }, 300);
        }

        function init() {
            console.log('Simple Filter Bar init');
            $scope.listFilterService.sync(vm);
            vm.filterBarService = $scope.listFilterService.getFilterService();
            vm.refreshGrid = $scope.listFilterService.refreshGrid;

            if (lodash.has(vm.options, 'grouping')) {
                vm.groupings = lodash.get(vm.options, 'grouping', []);
                if (vm.groupings.length > 0) {

                    selectGroup(vm.groupings[0]);
                }
            }


            $scope.$watch(function () {
                return $scope.listFilterService.getGrid().dataSource.total();
            }, function () {
                vm.count = $scope.listFilterService.getGrid().dataSource.total();
            });
        }

        function initListFilterService() {
            if (!$scope.listFilterService) {
                $scope.listFilterService = ListFilterStateFactory.get(listFilterIdentifier);
            }
        }

        function selectGroup(group) {
            vm.currentGroup = group;
            if (lodash.isEmpty(vm.currentDirection)) {
                vm.currentDirection = lodash.get(vm.options, 'default_direction', 'asc');
            } else {
                vm.currentDirection = (vm.currentDirection !== 'asc') ? 'asc' : 'desc';
            }
            var order = {
                field: vm.currentGroup.field,
                dir: vm.currentDirection
            };
            if (typeof vm.dropDownToggleOff === typeof function () {
            }) {
                vm.dropDownToggleOff();
            }
            $scope.listFilterService.getGrid().dataSource.group(order);
        }
    }
})();